<template>
  <div class="cr-toolbar tr-toolbar">
    <div class="cr-toolbar-field tr-field-mode">
      <label class="form-label">Filtrar por</label>
      <div class="btn-group">
        <button class="btn btn-sm view-toggle" :class="{'is-on': value.mode === 'competence'}"
                @click="set('mode', 'competence')">Competência</button>
        <button class="btn btn-sm view-toggle" :class="{'is-on': value.mode === 'period'}"
                @click="set('mode', 'period')">Período</button>
      </div>
    </div>

    <div class="cr-toolbar-field tr-field-competence" v-if="value.mode === 'competence'"
         :class="{'has-error': validator.competence.$error}">
      <competence-picker label="Competência" :months="MONTHS" :disabled="loading"
                         :value="pickerCompetence" @input="setCompetence"/>
      <div class="form-input-hint" v-if="validator.competence.$error">{{ competenceHint }}</div>
    </div>

    <div class="cr-toolbar-field tr-field-period" v-else :class="{'has-error': periodError}">
      <label class="form-label">Período <small>(até 6 meses)</small></label>
      <st-date-period
        :start-date="value.startDate"
        :end-date="value.endDate"
        :max-months="6"
        :start-date-validator="validator.startDate"
        :end-date-validator="validator.endDate"
        @update:startDate="set('startDate', $event)"
        @update:endDate="set('endDate', $event)"
        @blur:startDate="touch('startDate')"
        @blur:endDate="touch('endDate')"
      />
    </div>

    <div class="cr-toolbar-field tr-field-professional">
      <label class="form-label">Profissional</label>
      <select class="form-select" :value="value.professionalId"
              @change="set('professionalId', $event.target.value)">
        <option value="">Todos os profissionais</option>
        <option v-for="item in professionals" :value="item.id" :key="item.id">
          {{ item.name }}
        </option>
      </select>
    </div>

    <div class="cr-toolbar-field tr-field-insurance">
      <label class="form-label">Convênio</label>
      <select class="form-select" :value="value.planId"
              @change="set('planId', $event.target.value)">
        <option value="">Todos os convênios</option>
        <option v-for="item in insurances" :value="item.id" :key="item.id">{{ item.name }}</option>
      </select>
    </div>

    <div class="cr-toolbar-field tr-field-origin">
      <label class="form-label">Origem</label>
      <select class="form-select" :value="value.origin"
              @change="set('origin', $event.target.value)">
        <option value="all">Todas as origens</option>
        <option v-for="item in originItems" :value="item.value" :key="item.value">
          {{ item.label }}
        </option>
      </select>
    </div>

    <div class="cr-toolbar-field tr-field-status" :class="{'has-error': validator.statuses.$error}">
      <label class="form-label">Status</label>
      <st-multi-select :value="value.statuses" :items="statusItems"
                       value-key="value" label-key="label"
                       @input="set('statuses', $event)"/>
      <div class="form-input-hint" v-if="validator.statuses.$error">Campo obrigatório</div>
    </div>

    <div class="cr-toolbar-actions tr-field-search">
      <button class="btn btn-secondary btn-icon btn-icon-left"
              :class="{loading}" :disabled="loading" @click="$emit('search')">
        <fa-icon :icon="['fal', 'search']"/>Pesquisar
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { origins } from '@/data/billing-transfer-origins';
import { statuses } from '@/data/billing-transfer-statuses';
import CompetencePicker from '@/app/billing/batch/components/CompetencePicker.vue';

const MONTHS = 24;

export default {
  components: {
    CompetencePicker,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    validator: {
      type: Object,
      required: true,
    },
    professionals: {
      type: Array,
      default: () => [],
    },
    insurances: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      MONTHS,
    };
  },
  computed: {
    originItems() {
      return Object.keys(origins).map(value => ({ value, label: origins[value] }));
    },
    statusItems() {
      return Object.keys(statuses).map(value => ({ value, label: statuses[value] }));
    },
    pickerCompetence() {
      const current = moment(this.value.competence, 'MM/YYYY', true);
      return (current.isValid() ? current : moment()).format('YYYY-MM');
    },
    competenceHint() {
      return this.validator.competence.required === false
        ? 'Campo obrigatório'
        : 'Competência inválida';
    },
    periodError() {
      return this.validator.startDate.$error || this.validator.endDate.$error;
    },
  },
  methods: {
    set(key, newValue) {
      this.$emit('input', { ...this.value, [key]: newValue });
    },
    touch(key) {
      if (this.validator[key]) this.validator[key].$touch();
    },
    setCompetence(competence) {
      this.set('competence', moment(competence, 'YYYY-MM').format('MM/YYYY'));
    },
  },
};
</script>
